import { useContext } from "react";
import { MapContext } from "../components/MapProvider";

export default function useMap() {
    const context = useContext(MapContext);

    if (!context) {
        throw new Error("useMap should be used within MapProvider");
    }

    return context;
}